<div *ngIf="data" layout="row" [ngClass]="styles.kpiWrapper">
	<vb-ui-report-cell flex="1 1 0" [header]="'Event_Analytics_Kpi_TotalEvents' | translate" [headerTooltip]="'Event_Analytics_Kpi_TotalEvents_Info' | translate">
		<vb-ui-kpi [value]="data.totalEvents" [hideChangeIndicators]="true">
		</vb-ui-kpi>
	</vb-ui-report-cell>

	<vb-ui-report-cell flex="1 1 0" [header]="'Event_Analytics_Kpi_UniqueAttendees' | translate" [headerTooltip]="'Event_Analytics_Kpi_UniqueAttendees_Info' | translate">
		<vb-ui-kpi [value]="data.uniqueAttendees" [hideChangeIndicators]="true">
		</vb-ui-kpi>
	</vb-ui-report-cell>

	<vb-ui-report-cell flex="1 1 0" [header]="'Event_Analytics_Kpi_TotalDuration' | translate" [headerTooltip]="'Event_Analytics_Kpi_TotalDuration_Info' | translate">
		<span [ngClass]="styles.kpiData">
			{{ (data.totalDurationSecs * 1000) | vbTimespan:true:true }}
		</span>
	</vb-ui-report-cell>

	<vb-ui-report-cell flex="1 1 0" [header]="'Event_Analytics_Kpi_AverageDuration' | translate" [headerTooltip]="'Event_Analytics_Kpi_AverageDuration_Info' | translate">
		<span [ngClass]="styles.kpiData">
			{{ (data.avgDurationSecs * 1000) | vbTimespan:true:true }}
		</span>
	</vb-ui-report-cell>
</div>
